import { useRef, useEffect, useState } from 'react'
import { Helmet } from "react-helmet";
import db from "../../firebase-config"
import HeaderTumbler from '../../components/header/HeaderTumbler';
import { Box, Grid, Container, Tab, Tabs, Toolbar, Typography, useTheme, Button } from "@mui/material";
import { tokens } from "../../theme";
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import moment from 'moment-timezone';
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import CircularProgress from '@mui/material/CircularProgress';
import DonutChartMultiStepTime from '../../components/chart/DonutChartMultiStepTime';



const Item = styled(Paper)(({ theme }) => ({
    //backgroundColor: 'transparent',
    padding: theme.spacing(0.8),
    textAlign: 'center',
    border: '0.8px dashed #c2c2c2',
    borderRadius: "0px 0px 20px 20px",
    height: { xs: "87%", md: "100%" },

}));

const ItemUT = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(0.4),
    textAlign: 'center',
    backgroundColor: '#404040',
    borderRadius: "20px 20px 0px 0px"
    //height: '102%'

}));

const ItemMachine = styled(Paper)(({ theme }) => ({
    backgroundColor: '#049468',
    padding: theme.spacing(0.5),
    textAlign: 'center',
    //border: '0.5px dashed #4A4A49',
    borderRadius: 10,
    // height: '50%',
}));

const ItemManual = styled(Paper)(({ theme }) => ({
    backgroundColor: '#bcbcbc',
    padding: theme.spacing(0.5),
    textAlign: 'center',
    //border: '0.5px dashed #4A4A49',
    borderRadius: 10,
    // height: '50%',
}));


const formatDurationHHmm = (value) => {
    if (!value || value === "NA") return "-";
  
    if (typeof value === "string") {
      if (/^\d{2}:\d{2}$/.test(value)) {
        return value;
      }
  
      if (moment(value, "YYYY-MM-DD HH:mm:ss", true).isValid()) {
        return moment(value, "YYYY-MM-DD HH:mm:ss").format("HH:mm");
      }
    }
  
    let duration;
  
    if (moment.isDuration(value)) {
      duration = value;
    } else if (typeof value === "number") {
      duration = moment.duration(value, "seconds");
    } else if (typeof value === "string") {
      duration = moment.duration(value);
    } else {
      return "-";
    }
  
    const hours = Math.floor(duration.asHours())
      .toString()
      .padStart(2, "0");
  
    const minutes = duration.minutes()
      .toString()
      .padStart(2, "0");
  
    return `${hours}:${minutes}`;
  };

const TumblerTracking = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const today = new Date();
    const hourago = new Date(today.getTime());
    const time = moment(hourago).tz('Asia/Bangkok').format('HH:mm:ss');

    const [tumbler_tracking, setTumbler_tracking] = useState([])
    const [tumbler_tracking_dashboard, setTumbler_tracking_dashboard] = useState([])


    useEffect(() => {
        const subscriberTumbler = db
            .collection("prod_mes_ignition_tumbler_dashboard_tag_list")
            .onSnapshot((querySnapshot) => {
                const tumblerData = querySnapshot.docs.map(doc => ({
                    ...doc.data(),
                    id: doc.id,
                }));
                setTumbler_tracking(tumblerData);

            });

        const subscriberTumblerDashboard = db
            .collection("prod_mes_ignition_tumbler_dashboard")
            .onSnapshot((querySnapshot) => {
                const tumblerData = querySnapshot.docs.map(doc => ({
                    ...doc.data(),
                    id: doc.id,
                }));
                setTumbler_tracking_dashboard(tumblerData);
            });

        // Cleanup listeners
        return () => {
            subscriberTumbler();
            subscriberTumblerDashboard();
        };
    }, []);


    const formatSecondsToHHmm = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    };


    const getDifferenceInMinutes = (dateStr1, dateStr2) => {
        const date1 = new Date(dateStr1);
        const date2 = new Date(dateStr2);

        const diffInMs = date2 - date1;

        return Math.max(0, Math.ceil(diffInMs / (1000 * 60)));
    };

    //// machine 1(5083)
    const machine_status5083 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Simulator.4117.00000000000000.Thailand.Tumbler.SMD5083.Line.Connect"));
    const smd5083 = tumbler_tracking_dashboard === undefined ? '' : tumbler_tracking_dashboard.find((x) => x.id.includes("411700000000000000TumblerSMD5083"));
    const actual_step_1 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Further.4117.00000000000000.Thailand.Tumbler.SMD5083.Line.ActualStep"));
    const alarm_1 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Further.4117.00000000000000.Thailand.Tumbler.SMD5083.Line.Alarm"));
    const count_down_1 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Simulator.4117.00000000000000.Thailand.Tumbler.SMD5083.Line.Count_Down"));
    const machine_state_1 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Further.4117.00000000000000.Thailand.Tumbler.SMD5083.Line.MachineState"));
    const name_1 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Further.4117.00000000000000.Thailand.Tumbler.SMD5083.Line.Name"));
    const total_time_1 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Further.4117.00000000000000.Thailand.Tumbler.SMD5083.Line.TotalTime"));
    const reset_dashboard_1 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Simulator.4117.00000000000000.Thailand.Tumbler.SMD5083.Line.Reset_Dashboard"));
    const machine_1 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Simulator.4117.00000000000000.Thailand.Tumbler.SMD5083.Line.Machine"));

    const diff_1 = total_time_1?.VALUE == undefined ? 0 : (total_time_1?.VALUE - machine_1?.VALUE <= 0 ? 0 : total_time_1?.VALUE - machine_1?.VALUE)

    const color_machine_number1 = () => {
        let color;
        try {
            if (machine_status5083?.VALUE == false) {
                color = '#ffffff'
            } else if (machine_status5083?.VALUE == true && machine_state_1?.VALUE == 32 && alarm_1?.VALUE == 0) {
                color = '#0cc694'
            } else if (machine_status5083?.VALUE == true && machine_state_1?.VALUE != 32 && alarm_1?.VALUE == 1) {
                color = '#7d2e1e'
            } else if (machine_status5083?.VALUE == true && machine_state_1?.VALUE != 32 && alarm_1?.VALUE == 0) {
                color = '#848484'
            } else if (machine_status5083?.VALUE == true && machine_state_1?.VALUE == 32 && alarm_1?.VALUE == 1) {
                color = '#fccf55'
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const font_color_machine_number1 = () => {
        let color;
        try {
            if (machine_status5083?.VALUE == false) {
                color = '#000000'
            } else if (machine_status5083?.VALUE == true && machine_state_1?.VALUE == 32 && alarm_1?.VALUE == 0) {
                color = '#ffffff'
            } else if (machine_status5083?.VALUE == true && machine_state_1?.VALUE != 32 && alarm_1?.VALUE == 1) {
                color = '#ffffff'
            } else if (machine_status5083?.VALUE == true && machine_state_1?.VALUE != 32 && alarm_1?.VALUE == 0) {
                color = '#ffffff'
            } else if (machine_status5083?.VALUE == true && machine_state_1?.VALUE == 32 && alarm_1?.VALUE == 1) {
                color = '#ffffff'
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const background_color_machine_number1 = () => {
        let color;
        try {
            if (machine_status5083?.VALUE == false) {
                color = '#404040'
            } else if (machine_status5083?.VALUE == true && machine_state_1?.VALUE == 32 && alarm_1?.VALUE == 0) {
                color = 'transparent'
            } else if (machine_status5083?.VALUE == true && machine_state_1?.VALUE != 32 && alarm_1?.VALUE == 1) {
                color = 'transparent'
            } else if (machine_status5083?.VALUE == true && machine_state_1?.VALUE != 32 && alarm_1?.VALUE == 0) {
                color = 'transparent'
            } else if (machine_status5083?.VALUE == true && machine_state_1?.VALUE == 32 && alarm_1?.VALUE == 1) {
                color = 'transparent'
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const differenceInMinutes5083 = getDifferenceInMinutes(smd5083?.END_TIME1, smd5083?.END_TIME2);

    //// machine 2(5084)
    const machine_status5084 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Simulator.4117.00000000000000.Thailand.Tumbler.SMD5084.Line.Connect"));
    const smd5084 = tumbler_tracking_dashboard === undefined ? '' : tumbler_tracking_dashboard.find((x) => x.id.includes("411700000000000000TumblerSMD5084"));
    const actual_step_2 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Further.4117.00000000000000.Thailand.Tumbler.SMD5084.Line.ActualStep"));
    const alarm_2 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Further.4117.00000000000000.Thailand.Tumbler.SMD5084.Line.Alarm"));
    const count_down_2 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Simulator.4117.00000000000000.Thailand.Tumbler.SMD5084.Line.Count_Down"));
    const machine_state_2 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Further.4117.00000000000000.Thailand.Tumbler.SMD5084.Line.MachineState"));
    const name_2 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Further.4117.00000000000000.Thailand.Tumbler.SMD5084.Line.Name"));
    const total_time_2 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Further.4117.00000000000000.Thailand.Tumbler.SMD5084.Line.TotalTime"));
    const reset_dashboard_2 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Simulator.4117.00000000000000.Thailand.Tumbler.SMD5084.Line.Reset_Dashboard"));
    const machine_2 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Simulator.4117.00000000000000.Thailand.Tumbler.SMD5084.Line.Machine"));

    const diff_2 = total_time_2?.VALUE == undefined ? 0 : (total_time_2?.VALUE - machine_2?.VALUE <= 0 ? 0 : total_time_2?.VALUE - machine_2?.VALUE)


    const color_machine_number2 = () => {
        let color;
        try {
            if (machine_status5084?.VALUE == false) {
                color = '#ffffff'
            } else if (machine_status5084?.VALUE == true && machine_state_2?.VALUE == 32 && alarm_2?.VALUE == 0) {
                color = '#0cc694'
            } else if (machine_status5084?.VALUE == true && machine_state_2?.VALUE != 32 && alarm_2?.VALUE == 1) {
                color = '#7d2e1e'
            } else if (machine_status5084?.VALUE == true && machine_state_2?.VALUE != 32 && alarm_2?.VALUE == 0) {
                color = '#848484'
            } else if (machine_status5084?.VALUE == true && machine_state_2?.VALUE == 32 && alarm_2?.VALUE == 1) {
                color = '#fccf55'
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const font_color_machine_number2 = () => {
        let color;
        try {
            if (machine_status5084?.VALUE == false) {
                color = '#000000'
            } else if (machine_status5084?.VALUE == true && machine_state_2?.VALUE == 32 && alarm_2?.VALUE == 0) {
                color = '#ffffff'
            } else if (machine_status5084?.VALUE == true && machine_state_2?.VALUE != 32 && alarm_2?.VALUE == 1) {
                color = '#ffffff'
            } else if (machine_status5084?.VALUE == true && machine_state_2?.VALUE != 32 && alarm_2?.VALUE == 0) {
                color = '#ffffff'
            } else if (machine_status5084?.VALUE == true && machine_state_2?.VALUE == 32 && alarm_2?.VALUE == 1) {
                color = '#ffffff'
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const background_color_machine_number2 = () => {
        let color;
        try {
            if (machine_status5084?.VALUE == false) {
                color = '#404040'
            } else if (machine_status5084?.VALUE == true && machine_state_2?.VALUE == 32 && alarm_2?.VALUE == 0) {
                color = 'transparent'
            } else if (machine_status5084?.VALUE == true && machine_state_2?.VALUE != 32 && alarm_2?.VALUE == 1) {
                color = 'transparent'
            } else if (machine_status5084?.VALUE == true && machine_state_2?.VALUE != 32 && alarm_2?.VALUE == 0) {
                color = 'transparent'
            } else if (machine_status5084?.VALUE == true && machine_state_2?.VALUE == 32 && alarm_2?.VALUE == 1) {
                color = 'transparent'
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const differenceInMinutes5084 = getDifferenceInMinutes(smd5084?.END_TIME1, smd5084?.END_TIME2);


    //// machine 3(5085)
    const machine_status5085 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Simulator.4117.00000000000000.Thailand.Tumbler.SMD5085.Line.Connect"));
    const smd5085 = tumbler_tracking_dashboard === undefined ? '' : tumbler_tracking_dashboard.find((x) => x.id.includes("411700000000000000TumblerSMD5085"));
    const actual_step_3 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Further.4117.00000000000000.Thailand.Tumbler.SMD5085.Line.ActualStep"));
    const alarm_3 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Further.4117.00000000000000.Thailand.Tumbler.SMD5085.Line.Alarm"));
    const count_down_3 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Simulator.4117.00000000000000.Thailand.Tumbler.SMD5085.Line.Count_Down"));
    const machine_state_3 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Further.4117.00000000000000.Thailand.Tumbler.SMD5085.Line.MachineState"));
    const name_3 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Further.4117.00000000000000.Thailand.Tumbler.SMD5085.Line.Name"));
    const total_time_3 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Further.4117.00000000000000.Thailand.Tumbler.SMD5085.Line.TotalTime"));
    const reset_dashboard_3 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Simulator.4117.00000000000000.Thailand.Tumbler.SMD5085.Line.Reset_Dashboard"));
    const machine_3 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Simulator.4117.00000000000000.Thailand.Tumbler.SMD5085.Line.Machine"));

    const diff_3 = total_time_3?.VALUE == undefined ? 0 : (total_time_3?.VALUE - machine_3?.VALUE <= 0 ? 0 : total_time_3?.VALUE - machine_3?.VALUE)


    const color_machine_number3 = () => {
        let color;
        try {
            if (machine_status5085?.VALUE == false) {
                color = '#ffffff'
            } else if (machine_status5085?.VALUE == true && machine_state_3?.VALUE == 32 && alarm_3?.VALUE == 0) {
                color = '#0cc694'
            } else if (machine_status5085?.VALUE == true && machine_state_3?.VALUE != 32 && alarm_3?.VALUE == 1) {
                color = '#7d2e1e'
            } else if (machine_status5085?.VALUE == true && machine_state_3?.VALUE != 32 && alarm_3?.VALUE == 0) {
                color = '#848484'
            } else if (machine_status5085?.VALUE == true && machine_state_3?.VALUE == 32 && alarm_3?.VALUE == 1) {
                color = '#fccf55'
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const font_color_machine_number3 = () => {
        let color;
        try {
            if (machine_status5085?.VALUE == false) {
                color = '#000000'
            } else if (machine_status5085?.VALUE == true && machine_state_3?.VALUE == 32 && alarm_3?.VALUE == 0) {
                color = '#ffffff'
            } else if (machine_status5085?.VALUE == true && machine_state_3?.VALUE != 32 && alarm_3?.VALUE == 1) {
                color = '#ffffff'
            } else if (machine_status5085?.VALUE == true && machine_state_3?.VALUE != 32 && alarm_3?.VALUE == 0) {
                color = '#ffffff'
            } else if (machine_status5085?.VALUE == true && machine_state_3?.VALUE == 32 && alarm_3?.VALUE == 1) {
                color = '#ffffff'
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const background_color_machine_number3 = () => {
        let color;
        try {
            if (machine_status5085?.VALUE == false) {
                color = '#404040'
            } else if (machine_status5085?.VALUE == true && machine_state_3?.VALUE == 32 && alarm_3?.VALUE == 0) {
                color = 'transparent'
            } else if (machine_status5085?.VALUE == true && machine_state_3?.VALUE != 32 && alarm_3?.VALUE == 1) {
                color = 'transparent'
            } else if (machine_status5085?.VALUE == true && machine_state_3?.VALUE != 32 && alarm_3?.VALUE == 0) {
                color = 'transparent'
            } else if (machine_status5085?.VALUE == true && machine_state_3?.VALUE == 32 && alarm_3?.VALUE == 1) {
                color = 'transparent'
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const differenceInMinutes5085 = getDifferenceInMinutes(smd5085?.END_TIME1, smd5085?.END_TIME2);

    //// machine 4(5086)
    const machine_status5086 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Simulator.4117.00000000000000.Thailand.Tumbler.SMD5086.Line.Connect"));
    const smd5086 = tumbler_tracking_dashboard === undefined ? '' : tumbler_tracking_dashboard.find((x) => x.id.includes("411700000000000000TumblerSMD5086"));
    const actual_step_4 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Further.4117.00000000000000.Thailand.Tumbler.SMD5086.Line.ActualStep"));
    const alarm_4 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Further.4117.00000000000000.Thailand.Tumbler.SMD5086.Line.Alarm"));
    const count_down_4 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Simulator.4117.00000000000000.Thailand.Tumbler.SMD5086.Line.Count_Down"));
    const machine_state_4 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Further.4117.00000000000000.Thailand.Tumbler.SMD5086.Line.MachineState"));
    const name_4 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Further.4117.00000000000000.Thailand.Tumbler.SMD5086.Line.Name"));
    const total_time_4 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Further.4117.00000000000000.Thailand.Tumbler.SMD5086.Line.TotalTime"));
    const reset_dashboard_4 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Simulator.4117.00000000000000.Thailand.Tumbler.SMD5086.Line.Reset_Dashboard"));
    const machine_4 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Simulator.4117.00000000000000.Thailand.Tumbler.SMD5086.Line.Machine"));

    const diff_4 = total_time_4?.VALUE == undefined ? 0 : (total_time_4?.VALUE - machine_4?.VALUE <= 0 ? 0 : total_time_4?.VALUE - machine_4?.VALUE)


    const color_machine_number4 = () => {
        let color;
        try {
            if (machine_status5086?.VALUE == false) {
                color = '#ffffff'
            } else if (machine_status5086?.VALUE == true && machine_state_4?.VALUE == 32 && alarm_4?.VALUE == 0) {
                color = '#0cc694'
            } else if (machine_status5086?.VALUE == true && machine_state_4?.VALUE != 32 && alarm_4?.VALUE == 1) {
                color = '#7d2e1e'
            } else if (machine_status5086?.VALUE == true && machine_state_4?.VALUE != 32 && alarm_4?.VALUE == 0) {
                color = '#848484'
            } else if (machine_status5086?.VALUE == true && machine_state_4?.VALUE == 32 && alarm_4?.VALUE == 1) {
                color = '#fccf55'
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const font_color_machine_number4 = () => {
        let color;
        try {
            if (machine_status5086?.VALUE == false) {
                color = '#000000'
            } else if (machine_status5086?.VALUE == true && machine_state_4?.VALUE == 32 && alarm_4?.VALUE == 0) {
                color = '#ffffff'
            } else if (machine_status5086?.VALUE == true && machine_state_4?.VALUE != 32 && alarm_4?.VALUE == 1) {
                color = '#ffffff'
            } else if (machine_status5086?.VALUE == true && machine_state_4?.VALUE != 32 && alarm_4?.VALUE == 0) {
                color = '#ffffff'
            } else if (machine_status5086?.VALUE == true && machine_state_4?.VALUE == 32 && alarm_4?.VALUE == 1) {
                color = '#ffffff'
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const background_color_machine_number4 = () => {
        let color;
        try {
            if (machine_status5086?.VALUE == false) {
                color = '#404040'
            } else if (machine_status5086?.VALUE == true && machine_state_4?.VALUE == 32 && alarm_4?.VALUE == 0) {
                color = 'transparent'
            } else if (machine_status5086?.VALUE == true && machine_state_4?.VALUE != 32 && alarm_4?.VALUE == 1) {
                color = 'transparent'
            } else if (machine_status5086?.VALUE == true && machine_state_4?.VALUE != 32 && alarm_4?.VALUE == 0) {
                color = 'transparent'
            } else if (machine_status5086?.VALUE == true && machine_state_4?.VALUE == 32 && alarm_4?.VALUE == 1) {
                color = 'transparent'
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const differenceInMinutes5086 = getDifferenceInMinutes(smd5086?.END_TIME1, smd5086?.END_TIME2);

    //// machine 5(5087)
    const machine_status5087 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Simulator.4117.00000000000000.Thailand.Tumbler.SMD5087.Line.Connect"));
    const smd5087 = tumbler_tracking_dashboard === undefined ? '' : tumbler_tracking_dashboard.find((x) => x.id.includes("411700000000000000TumblerSMD5087"));
    const actual_step_5 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Further.4117.00000000000000.Thailand.Tumbler.SMD5087.Line.ActualStep"));
    const alarm_5 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Further.4117.00000000000000.Thailand.Tumbler.SMD5087.Line.Alarm"));
    const count_down_5 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Simulator.4117.00000000000000.Thailand.Tumbler.SMD5087.Line.Count_Down"));
    const machine_state_5 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Further.4117.00000000000000.Thailand.Tumbler.SMD5087.Line.MachineState"));
    const name_5 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Further.4117.00000000000000.Thailand.Tumbler.SMD5087.Line.Name"));
    const total_time_5 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Further.4117.00000000000000.Thailand.Tumbler.SMD5087.Line.TotalTime"));
    const reset_dashboard_5 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Simulator.4117.00000000000000.Thailand.Tumbler.SMD5087.Line.Reset_Dashboard"));
    const machine_5 = tumbler_tracking === undefined ? '' : tumbler_tracking.find((x) => x.id.includes("Simulator.4117.00000000000000.Thailand.Tumbler.SMD5087.Line.Machine"));

    const diff_5 = total_time_5?.VALUE == undefined ? 0 : (total_time_5?.VALUE - machine_5?.VALUE <= 0 ? 0 : total_time_5?.VALUE - machine_5?.VALUE)


    const color_machine_number5 = () => {
        let color;
        try {
            if (machine_status5087?.VALUE == false) {
                color = '#ffffff'
            } else if (machine_status5087?.VALUE == true && machine_state_5?.VALUE == 32 && alarm_5?.VALUE == 0) {
                color = '#0cc694'
            } else if (machine_status5087?.VALUE == true && machine_state_5?.VALUE != 32 && alarm_5?.VALUE == 1) {
                color = '#7d2e1e'
            } else if (machine_status5087?.VALUE == true && machine_state_5?.VALUE != 32 && alarm_5?.VALUE == 0) {
                color = '#848484'
            } else if (machine_status5087?.VALUE == true && machine_state_5?.VALUE == 32 && alarm_5?.VALUE == 1) {
                color = '#fccf55'
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const font_color_machine_number5 = () => {
        let color;
        try {
            if (machine_status5087?.VALUE == false) {
                color = '#000000'
            } else if (machine_status5087?.VALUE == true && machine_state_5?.VALUE == 32 && alarm_5?.VALUE == 0) {
                color = '#ffffff'
            } else if (machine_status5087?.VALUE == true && machine_state_5?.VALUE != 32 && alarm_5?.VALUE == 1) {
                color = '#ffffff'
            } else if (machine_status5087?.VALUE == true && machine_state_5?.VALUE != 32 && alarm_5?.VALUE == 0) {
                color = '#ffffff'
            } else if (machine_status5087?.VALUE == true && machine_state_5?.VALUE == 32 && alarm_5?.VALUE == 1) {
                color = '#ffffff'
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const background_color_machine_number5 = () => {
        let color;
        try {
            if (machine_status5087?.VALUE == false) {
                color = '#404040'
            } else if (machine_status5087?.VALUE == true && machine_state_5?.VALUE == 32 && alarm_5?.VALUE == 0) {
                color = 'transparent'
            } else if (machine_status5087?.VALUE == true && machine_state_5?.VALUE != 32 && alarm_5?.VALUE == 1) {
                color = 'transparent'
            } else if (machine_status5087?.VALUE == true && machine_state_5?.VALUE != 32 && alarm_5?.VALUE == 0) {
                color = 'transparent'
            } else if (machine_status5087?.VALUE == true && machine_state_5?.VALUE == 32 && alarm_5?.VALUE == 1) {
                color = 'transparent'
            }
            return color;
        }
        catch {
            console.log()
        }
    }
    const differenceInMinutes5087 = getDifferenceInMinutes(smd5087?.END_TIME1, smd5087?.END_TIME2);


    return (
        <>
            <Helmet>
                <title>Tumbler Tracking  | MES</title>
            </Helmet>
            <Grid container spacing={1} >
                <Grid item xs={12}>
                    <HeaderTumbler
                        header={'Tumbler Tracking'}
                        icon={time.toString() >= '06:00:00' && time.toString() <= '18:00:00' ? <LightModeOutlinedIcon style={{ color: '#ffffff' }} /> : <DarkModeOutlinedIcon style={{ color: '#ffffff' }} />}
                    />
                </Grid>
                <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 0.5, md: 0.5 }} style={{ paddingTop: 3, paddingLeft: 30, paddingRight: 0, backgroundColor: colors.neutral['black'] }}>
                    {reset_dashboard_1?.VALUE == true
                        ? <Grid item xs={2.32} style={{ height: '284px' }}>
                            <ItemUT>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 3 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                        <Button
                                            variant="outlined"
                                            sx={{
                                                width: 38,
                                                height: 38,
                                                borderRadius: "50%",
                                                minWidth: "unset",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: 0,
                                                fontSize: 28,
                                                fontWeight: "bold",
                                                color: machine_status5083?.VALUE == undefined ? '#ffffff' : font_color_machine_number1(),
                                                backgroundColor: color_machine_number1(),
                                                borderColor: machine_status5083?.VALUE == undefined ? '#848484' : color_machine_number1(),
                                                transition: "0.2s ease-in-out",
                                                pointerEvents: "none",
                                            }}
                                        >
                                            1
                                        </Button>
                                    </Box>
                                </Grid>
                            </ItemUT>
                            <Item sx={{ minHeight: { xs: "245px", md: "515px" }, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', background: machine_status5083?.VALUE == undefined ? 'transparent' : background_color_machine_number1() }}>
                                <Grid item xs={12} textAlign="center" sx={{ position: "relative", marginTop: { xs: "10px", md: "32px" } }}>
                                    <DonutChartMultiStepTime
                                        act={0}
                                        diff={10}
                                        step={''}
                                        time={''}
                                        mins={''}
                                    />
                                </Grid>
                            </Item>
                        </Grid>
                        : <Grid item xs={2.32} style={{ height: '284px' }}>
                            <ItemUT>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 3 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                        <Button
                                            variant="outlined"
                                            sx={{
                                                width: 38,
                                                height: 38,
                                                borderRadius: "50%",
                                                minWidth: "unset",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: 0,
                                                fontSize: 28,
                                                fontWeight: "bold",
                                                color: machine_status5083?.VALUE == undefined ? '#ffffff' : font_color_machine_number1(),
                                                backgroundColor: color_machine_number1(),
                                                borderColor: machine_status5083?.VALUE == undefined ? '#848484' : color_machine_number1(),
                                                transition: "0.2s ease-in-out",
                                                pointerEvents: "none"
                                            }}
                                        >
                                            1
                                        </Button>
                                    </Box>
                                </Grid>
                            </ItemUT>
                            <Item sx={{ minHeight: { xs: "245px", md: "515px" }, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', background: machine_status5083?.VALUE == undefined ? 'transparent' : background_color_machine_number1() }}>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 15 }}>
                                    <Typography style={{ color: colors.neutral['white'], fontSize: 40, lineHeight: "0px", paddingTop: 0 }} >
                                        {name_1?.VALUE == undefined ? '' : name_1?.VALUE}
                                    </Typography>
                                </Grid>
                                {machine_state_1?.VALUE == 1024
                                    ? <Grid item xs={12} textAlign="center" sx={{ position: "relative", marginTop: { xs: "10px", md: "28px" }, marginBottom: { xs: "16vh", md: "1.2vh" } }}>
                                        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                                            <CircularProgress size={160} style={{ color: '#0cc694' }} />
                                            <Box
                                                sx={{
                                                    top: 0,
                                                    left: 0,
                                                    bottom: 0,
                                                    right: 0,
                                                    position: 'absolute',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: '24px',
                                                    color: '#fff',
                                                    fontFamily: 'CPF_Imm_Sook',
                                                    fontWeight: 'bold',
                                                }}
                                            >
                                                Loading...
                                            </Box>
                                        </Box>
                                    </Grid>
                                    : <Grid item xs={12} textAlign="center" sx={{ position: "relative", marginTop: { xs: "5px", md: "14px" } }}>
                                        <DonutChartMultiStepTime
                                            act={(machine_1?.VALUE == undefined ? 0 : machine_1?.VALUE)}
                                            diff={diff_1}
                                            step={'Step ' + (actual_step_1?.VALUE == undefined ? '' : actual_step_1?.VALUE)}
                                            time={count_down_1?.VALUE == undefined ? '00:00' : formatSecondsToHHmm(count_down_1?.VALUE)}
                                            mins={''}
                                        />
                                    </Grid>}
                                <Grid item xs={12} textAlign="center" sx={{ position: "relative", marginTop: { xs: "-46px", md: "10px" } }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                        <table style={{ width: '50%' }}>
                                            <tbody>
                                                <tr >
                                                    <td style={{ width: '40%', color: colors.neutral['grey'], fontSize: 36, lineHeight: "5vh" }} align="left">
                                                        Start&nbsp;
                                                    </td>
                                                    <td style={{ width: '20%', color: colors.neutral['white'], fontSize: 46, fontWeight: 'bold', lineHeight: "5vh" }} align="right">
                                                        {smd5083?.START_TIME == undefined ? '00:00' : formatDurationHHmm(smd5083?.START_TIME)}
                                                    </td>
                                                </tr>

                                                <tr >
                                                    <td style={{ width: '40%', color: colors.neutral['grey'], fontSize: 36, lineHeight: "10vh", paddingTop: 5 }} align="left">
                                                        End
                                                    </td>
                                                    <td style={{ width: '20%', color: smd5083?.END_TIME2 == undefined ? colors.neutral['white'] : smd5083?.END_TIME2 <= 0 ? colors.neutral['grey'] : colors.neutral['white'], fontSize: 46, fontWeight: 'bold', lineHeight: "10vh" }} align="left">
                                                        {smd5083?.END_TIME2 == undefined ? '00:00' : smd5083?.END_TIME2 <= 0 ? formatDurationHHmm(smd5083?.END_TIME1) : formatDurationHHmm(smd5083?.END_TIME2)}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 0, paddingRight: 5, paddingLeft: 5, marginTop: '-5px' }}>
                                    <Grid container rowSpacing={0} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
                                        <Grid item xs={6} >
                                            <Grid item xs={12} textAlign="center" >
                                                <Typography style={{ color: colors.neutral['white'], fontSize: 32, lineHeight: "8vh" }} >
                                                    Machine
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} textAlign="center"  >
                                                <ItemMachine style={{ height: '12vh' }}>
                                                    <Grid item xs={12}>
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 64, fontWeight: 'bold', lineHeight: "10vh" }} textAlign="center">
                                                            {(machine_1?.VALUE == undefined ? 0 : Math.round(machine_1?.VALUE / 60))}
                                                        </Typography>
                                                    </Grid>
                                                </ItemMachine>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={6} style={{ paddingLeft: 5 }}>
                                            <Grid item xs={12} textAlign="center" >
                                                <Typography style={{ color: colors.neutral['white'], fontSize: 32, lineHeight: "8vh" }} >
                                                    Manual
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} textAlign="center" >
                                                <ItemManual style={{ height: '12vh' }}>
                                                    <Grid item xs={12} textAlign="center" >
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 64, fontWeight: 'bold', lineHeight: "10vh" }} textAlign="center">
                                                            {smd5083?.END_TIME2 == undefined || smd5083?.END_TIME2 === "00:00" ? 0 : smd5083?.END_TIME2 <= 0 ? 0 : differenceInMinutes5083}
                                                        </Typography>
                                                    </Grid>
                                                </ItemManual>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Item>
                        </Grid>
                    }

                    {reset_dashboard_2?.VALUE == true
                        ? <Grid item xs={2.32} style={{ height: '284px' }}>
                            <ItemUT>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 3 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                        <Button
                                            variant="outlined"
                                            sx={{
                                                width: 38,
                                                height: 38,
                                                borderRadius: "50%",
                                                minWidth: "unset",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: 0,
                                                fontSize: 28,
                                                fontWeight: "bold",
                                                color: machine_status5084?.VALUE == undefined ? '#ffffff' : font_color_machine_number2(),
                                                backgroundColor: color_machine_number2(),
                                                borderColor: machine_status5084?.VALUE == undefined ? '#848484' : color_machine_number2(),
                                                transition: "0.2s ease-in-out",
                                                pointerEvents: "none",
                                            }}
                                        >
                                            2
                                        </Button>
                                    </Box>
                                </Grid>
                            </ItemUT>
                            <Item sx={{ minHeight: { xs: "245px", md: "515px" }, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', background: machine_status5084?.VALUE == undefined ? 'transparent' : background_color_machine_number2() }}>
                                <Grid item xs={12} textAlign="center" sx={{ position: "relative", marginTop: { xs: "10px", md: "32px" } }}>
                                    <DonutChartMultiStepTime
                                        act={0}
                                        diff={10}
                                        step={''}
                                        time={''}
                                        mins={''}
                                    />
                                </Grid>
                            </Item>
                        </Grid>
                        : <Grid item xs={2.32} style={{ height: '284px' }}>
                            <ItemUT>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 3 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                        <Button
                                            variant="outlined"
                                            sx={{
                                                width: 38,
                                                height: 38,
                                                borderRadius: "50%",
                                                minWidth: "unset",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: 0,
                                                fontSize: 28,
                                                fontWeight: "bold",
                                                color: machine_status5084?.VALUE == undefined ? '#ffffff' : font_color_machine_number2(),
                                                backgroundColor: color_machine_number2(),
                                                borderColor: machine_status5084?.VALUE == undefined ? '#848484' : color_machine_number2(),
                                                transition: "0.2s ease-in-out",
                                                pointerEvents: "none"
                                            }}
                                        >
                                            2
                                        </Button>                           
                                    </Box>
                                </Grid>
                            </ItemUT>
                            <Item sx={{ minHeight: { xs: "245px", md: "500px" }, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', background: machine_status5084?.VALUE == undefined ? 'transparent' : background_color_machine_number2() }}>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 15 }}>
                                    <Typography style={{ color: colors.neutral['white'], fontSize: 40, lineHeight: "0px", paddingTop: 0 }} >
                                        {name_2?.VALUE == undefined ? '' : name_2?.VALUE}
                                    </Typography>
                                </Grid>
                                {machine_state_2?.VALUE == 1024
                                    ? <Grid item xs={12} textAlign="center" sx={{ position: "relative", marginTop: { xs: "10px", md: "28px" }, marginBottom: { xs: "16vh", md: "1.2vh" } }}>
                                        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                                            <CircularProgress size={160} style={{ color: '#0cc694' }} />
                                            <Box
                                                sx={{
                                                    top: 0,
                                                    left: 0,
                                                    bottom: 0,
                                                    right: 0,
                                                    position: 'absolute',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: '24px', 
                                                    color: '#fff',
                                                    fontFamily: 'CPF_Imm_Sook',
                                                    fontWeight: 'bold',
                                                }}
                                            >
                                                Loading...
                                            </Box>
                                        </Box>
                                    </Grid>
                                    : <Grid item xs={12} textAlign="center" sx={{ position: "relative", marginTop: { xs: "5px", md: "14px" } }}>
                                        <DonutChartMultiStepTime
                                            act={(machine_2?.VALUE == undefined ? 0 : machine_2?.VALUE)}
                                            diff={diff_2}
                                            step={'Step ' + (actual_step_2?.VALUE == undefined ? '' : actual_step_2?.VALUE)}
                                            time={count_down_2?.VALUE == undefined ? '00:00' : formatSecondsToHHmm(count_down_2?.VALUE)}
                                            mins={''}
                                        />
                                    </Grid>}
                                <Grid item xs={12} textAlign="center" sx={{ position: "relative", marginTop: { xs: "-46px", md: "10px" } }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                        <table style={{ width: '50%' }}>
                                            <tbody>
                                                <tr >
                                                    <td style={{ width: '40%', color: colors.neutral['grey'], fontSize: 36, lineHeight: "5vh" }} align="left">
                                                        Start&nbsp;
                                                    </td>
                                                    <td style={{ width: '20%', color: colors.neutral['white'], fontSize: 46, fontWeight: 'bold', lineHeight: "5vh" }} align="right">
                                                        {smd5084?.START_TIME == undefined ? '00:00' : formatDurationHHmm(smd5084?.START_TIME)}
                                                    </td>
                                                </tr>

                                                <tr >
                                                    <td style={{ width: '40%', color: colors.neutral['grey'], fontSize: 36, lineHeight: "10vh", paddingTop: 5 }} align="left">
                                                        End
                                                    </td>
                                                    <td style={{ width: '20%', color: smd5084?.END_TIME2 == undefined ? colors.neutral['white'] : smd5084?.END_TIME2 <= 0 ? colors.neutral['grey'] : colors.neutral['white'], fontSize: 46, fontWeight: 'bold', lineHeight: "10vh" }} align="left">
                                                        {smd5084?.END_TIME2 == undefined ? '00:00' : smd5084?.END_TIME2 <= 0 ? formatDurationHHmm(smd5084?.END_TIME1) : formatDurationHHmm(smd5084?.END_TIME2)}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 0, paddingRight: 5, paddingLeft: 5, marginTop: '-5px' }}>
                                    <Grid container rowSpacing={0} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
                                        <Grid item xs={6} >
                                            <Grid item xs={12} textAlign="center" >
                                                <Typography style={{ color: colors.neutral['white'], fontSize: 32, lineHeight: "8vh" }} >
                                                    Machine
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} textAlign="center"  >
                                                <ItemMachine style={{ height: '12vh' }}>
                                                    <Grid item xs={12}>
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 64, fontWeight: 'bold', lineHeight: "10vh" }} textAlign="center">
                                                            {(machine_2?.VALUE == undefined ? 0 : Math.round(machine_2?.VALUE / 60))}
                                                        </Typography>
                                                    </Grid>
                                                </ItemMachine>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={6} style={{ paddingLeft: 5 }}>
                                            <Grid item xs={12} textAlign="center" >
                                                <Typography style={{ color: colors.neutral['white'], fontSize: 32, lineHeight: "8vh" }} >
                                                    Manual
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} textAlign="center" >
                                                <ItemManual style={{ height: '12vh' }}>
                                                    <Grid item xs={12} textAlign="center" >
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 64, fontWeight: 'bold', lineHeight: "10vh" }} textAlign="center">
                                                            {smd5084?.END_TIME2 == undefined || smd5084?.END_TIME2 === "00:00" ? 0 : smd5084?.END_TIME2 <= 0 ? 0 : differenceInMinutes5084}
                                                        </Typography>
                                                    </Grid>
                                                </ItemManual>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Item>
                        </Grid>
                    }

                    {reset_dashboard_3?.VALUE == true
                        ? <Grid item xs={2.32} style={{ height: '284px' }}>
                            <ItemUT>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 3 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                        <Button
                                            variant="outlined"
                                            sx={{
                                                width: 38,
                                                height: 38,
                                                borderRadius: "50%",
                                                minWidth: "unset",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: 0,
                                                fontSize: 28,
                                                fontWeight: "bold",
                                                color: machine_status5085?.VALUE == undefined ? '#ffffff' : font_color_machine_number3(),
                                                backgroundColor: color_machine_number3(),
                                                borderColor: machine_status5085?.VALUE == undefined ? '#848484' : color_machine_number3(),
                                                transition: "0.2s ease-in-out",
                                                pointerEvents: "none",
                                            }}
                                        >
                                            3
                                        </Button>                                       
                                    </Box>
                                </Grid>
                            </ItemUT>
                            <Item sx={{ minHeight: { xs: "245px", md: "515px" }, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', background: machine_status5085?.VALUE == undefined ? 'transparent' : background_color_machine_number3() }}>
                                <Grid item xs={12} textAlign="center" sx={{ position: "relative", marginTop: { xs: "10px", md: "32px" } }}>
                                    <DonutChartMultiStepTime
                                        act={0}
                                        diff={10}
                                        step={''}
                                        time={''}
                                        mins={''}
                                    />
                                </Grid>
                            </Item>
                        </Grid>
                        : <Grid item xs={2.32} style={{ height: '284px' }}>
                            <ItemUT>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 3 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                        <Button
                                            variant="outlined"
                                            sx={{
                                                width: 38,
                                                height: 38,
                                                borderRadius: "50%",
                                                minWidth: "unset",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: 0,
                                                fontSize: 28,
                                                fontWeight: "bold",
                                                color: machine_status5085?.VALUE == undefined ? '#ffffff' : font_color_machine_number3(),
                                                backgroundColor: color_machine_number3(),
                                                borderColor: machine_status5085?.VALUE == undefined ? '#848484' : color_machine_number3(),
                                                transition: "0.2s ease-in-out",
                                                pointerEvents: "none"
                                            }}
                                        >
                                            3
                                        </Button>
                                    </Box>
                                </Grid>
                            </ItemUT>
                            <Item sx={{ minHeight: { xs: "245px", md: "500px" }, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', background: machine_status5085?.VALUE == undefined ? 'transparent' : background_color_machine_number3() }}>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 15 }}>
                                    <Typography style={{ color: colors.neutral['white'], fontSize: 40, lineHeight: "0px", paddingTop: 0 }} >
                                        {name_3?.VALUE == undefined ? '' : name_3?.VALUE}
                                    </Typography>
                                </Grid>
                                {machine_state_3?.VALUE == 1024
                                    ? <Grid item xs={12} textAlign="center" sx={{ position: "relative", marginTop: { xs: "10px", md: "28px" }, marginBottom: { xs: "16vh", md: "1.2vh" } }}>
                                        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                                            <CircularProgress size={160} style={{ color: '#0cc694' }} />
                                            <Box
                                                sx={{
                                                    top: 0,
                                                    left: 0,
                                                    bottom: 0,
                                                    right: 0,
                                                    position: 'absolute',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: '24px', 
                                                    color: '#fff',
                                                    fontFamily: 'CPF_Imm_Sook',
                                                    fontWeight: 'bold',
                                                }}
                                            >
                                                Loading...
                                            </Box>
                                        </Box>
                                    </Grid>
                                    : <Grid item xs={12} textAlign="center" sx={{ position: "relative", marginTop: { xs: "5px", md: "14px" } }}>
                                        <DonutChartMultiStepTime
                                            act={(machine_3?.VALUE == undefined ? 0 : machine_3?.VALUE)}
                                            diff={diff_3}
                                            step={'Step ' + (actual_step_3?.VALUE == undefined ? '' : actual_step_3?.VALUE)}
                                            time={count_down_3?.VALUE == undefined ? '00:00' : formatSecondsToHHmm(count_down_3?.VALUE)}
                                            mins={''}
                                        />
                                    </Grid>}
                                <Grid item xs={12} textAlign="center" sx={{ position: "relative", marginTop: { xs: "-46px", md: "10px" } }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                        <table style={{ width: '50%' }}>
                                            <tbody>
                                                <tr >
                                                    <td style={{ width: '40%', color: colors.neutral['grey'], fontSize: 36, lineHeight: "5vh" }} align="left">
                                                        Start&nbsp;
                                                    </td>
                                                    <td style={{ width: '20%', color: colors.neutral['white'], fontSize: 46, fontWeight: 'bold', lineHeight: "5vh" }} align="right">
                                                        {smd5085?.START_TIME == undefined ? '00:00' : formatDurationHHmm(smd5085?.START_TIME)}
                                                    </td>
                                                </tr>

                                                <tr >
                                                    <td style={{ width: '40%', color: colors.neutral['grey'], fontSize: 36, lineHeight: "10vh", paddingTop: 5 }} align="left">
                                                        End
                                                    </td>
                                                    <td style={{ width: '20%', color: smd5085?.END_TIME2 == undefined ? colors.neutral['white'] : smd5085?.END_TIME2 <= 0 ? colors.neutral['grey'] : colors.neutral['white'], fontSize: 46, fontWeight: 'bold', lineHeight: "10vh" }} align="left">
                                                        {smd5085?.END_TIME2 == undefined ? '00:00' : smd5085?.END_TIME2 <= 0 ? formatDurationHHmm(smd5085?.END_TIME1) : formatDurationHHmm(smd5085?.END_TIME2)}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 0, paddingRight: 5, paddingLeft: 5, marginTop: '-5px' }}>
                                    <Grid container rowSpacing={0} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
                                        <Grid item xs={6} >
                                            <Grid item xs={12} textAlign="center" >
                                                <Typography style={{ color: colors.neutral['white'], fontSize: 32, lineHeight: "8vh" }} >
                                                    Machine
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} textAlign="center"  >
                                                <ItemMachine style={{ height: '12vh' }}>
                                                    <Grid item xs={12}>
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 64, fontWeight: 'bold', lineHeight: "10vh" }} textAlign="center">
                                                            {(machine_3?.VALUE == undefined ? 0 : Math.round(machine_3?.VALUE / 60))}
                                                        </Typography>
                                                    </Grid>
                                                </ItemMachine>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={6} style={{ paddingLeft: 5 }}>
                                            <Grid item xs={12} textAlign="center" >
                                                <Typography style={{ color: colors.neutral['white'], fontSize: 32, lineHeight: "8vh" }} >
                                                    Manual
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} textAlign="center" >
                                                <ItemManual style={{ height: '12vh' }}>
                                                    <Grid item xs={12} textAlign="center" >
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 64, fontWeight: 'bold', lineHeight: "10vh" }} textAlign="center">
                                                            {smd5085?.END_TIME2 == undefined || smd5085?.END_TIME2 === "00:00" ? 0 : smd5085?.END_TIME2 <= 0 ? 0 : differenceInMinutes5085}
                                                        </Typography>
                                                    </Grid>
                                                </ItemManual>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Item>
                        </Grid>
                    }

                    {reset_dashboard_4?.VALUE == true
                        ? <Grid item xs={2.32} style={{ height: '284px' }}>
                            <ItemUT>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 3 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                        <Button
                                            variant="outlined"
                                            sx={{
                                                width: 38,
                                                height: 38,
                                                borderRadius: "50%",
                                                minWidth: "unset",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: 0,
                                                fontSize: 28,
                                                fontWeight: "bold",
                                                color: machine_status5086?.VALUE == undefined ? '#ffffff' : font_color_machine_number4(),
                                                backgroundColor: color_machine_number4(),
                                                borderColor: machine_status5086?.VALUE == undefined ? '#848484' : color_machine_number4(),
                                                transition: "0.2s ease-in-out",
                                                pointerEvents: "none",
                                            }}
                                        >
                                            4
                                        </Button>
                                    </Box>
                                </Grid>
                            </ItemUT>
                            <Item sx={{ minHeight: { xs: "245px", md: "515px" }, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', background: machine_status5086?.VALUE == undefined ? 'transparent' : background_color_machine_number4() }}>
                                <Grid item xs={12} textAlign="center" sx={{ position: "relative", marginTop: { xs: "10px", md: "32px" } }}>
                                    <DonutChartMultiStepTime
                                        act={0}
                                        diff={10}
                                        step={''}
                                        time={''}
                                        mins={''}
                                    />
                                </Grid>
                            </Item>
                        </Grid>
                        : <Grid item xs={2.32} style={{ height: '284px' }}>
                            <ItemUT>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 3 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                        <Button
                                            variant="outlined"
                                            sx={{
                                                width: 38,
                                                height: 38,
                                                borderRadius: "50%",
                                                minWidth: "unset",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: 0,
                                                fontSize: 28,
                                                fontWeight: "bold",
                                                color: machine_status5086?.VALUE == undefined ? '#ffffff' : font_color_machine_number4(),
                                                backgroundColor: color_machine_number4(),
                                                borderColor: machine_status5086?.VALUE == undefined ? '#848484' : color_machine_number4(),
                                                transition: "0.2s ease-in-out",
                                                pointerEvents: "none"
                                            }}
                                        >
                                            4
                                        </Button>
                                    </Box>
                                </Grid>
                            </ItemUT>
                            <Item sx={{ minHeight: { xs: "245px", md: "500px" }, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', background: machine_status5086?.VALUE == undefined ? 'transparent' : background_color_machine_number4() }}>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 15 }}>
                                    <Typography style={{ color: colors.neutral['white'], fontSize: 40, lineHeight: "0px", paddingTop: 0 }} >
                                        {name_4?.VALUE == undefined ? '' : name_4?.VALUE}
                                    </Typography>
                                </Grid>
                                {machine_state_4?.VALUE == 1024
                                    ? <Grid item xs={12} textAlign="center" sx={{ position: "relative", marginTop: { xs: "10px", md: "28px" }, marginBottom: { xs: "16vh", md: "1.2vh" } }}>
                                        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                                            <CircularProgress size={160} style={{ color: '#0cc694' }} />
                                            <Box
                                                sx={{
                                                    top: 0,
                                                    left: 0,
                                                    bottom: 0,
                                                    right: 0,
                                                    position: 'absolute',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: '24px',
                                                    color: '#fff',
                                                    fontFamily: 'CPF_Imm_Sook',
                                                    fontWeight: 'bold',
                                                }}
                                            >
                                                Loading...
                                            </Box>
                                        </Box>
                                    </Grid>
                                    : <Grid item xs={12} textAlign="center" sx={{ position: "relative", marginTop: { xs: "5px", md: "14px" } }}>
                                        <DonutChartMultiStepTime
                                            act={(machine_4?.VALUE == undefined ? 0 : machine_4?.VALUE)}
                                            diff={diff_4}
                                            step={'Step ' + (actual_step_4?.VALUE == undefined ? '' : actual_step_4?.VALUE)}
                                            time={count_down_4?.VALUE == undefined ? '00:00' : formatSecondsToHHmm(count_down_4?.VALUE)}
                                            mins={''}
                                        />
                                    </Grid>}
                                <Grid item xs={12} textAlign="center" sx={{ position: "relative", marginTop: { xs: "-46px", md: "10px" } }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                        <table style={{ width: '50%' }}>
                                            <tbody>
                                                <tr >
                                                    <td style={{ width: '40%', color: colors.neutral['grey'], fontSize: 36, lineHeight: "5vh" }} align="left">
                                                        Start&nbsp;
                                                    </td>
                                                    <td style={{ width: '20%', color: colors.neutral['white'], fontSize: 46, fontWeight: 'bold', lineHeight: "5vh" }} align="right">
                                                        {smd5086?.START_TIME == undefined ? '00:00' : formatDurationHHmm(smd5086?.START_TIME)}
                                                    </td>
                                                </tr>

                                                <tr >
                                                    <td style={{ width: '40%', color: colors.neutral['grey'], fontSize: 36, lineHeight: "10vh", paddingTop: 5 }} align="left">
                                                        End
                                                    </td>
                                                    <td style={{ width: '20%', color: smd5086?.END_TIME2 == undefined ? colors.neutral['white'] : smd5086?.END_TIME2 <= 0 ? colors.neutral['grey'] : colors.neutral['white'], fontSize: 46, fontWeight: 'bold', lineHeight: "10vh" }} align="left">
                                                        {smd5086?.END_TIME2 == undefined ? '00:00' : smd5086?.END_TIME2 <= 0 ? formatDurationHHmm(smd5086?.END_TIME1) : formatDurationHHmm(smd5086?.END_TIME2)}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 0, paddingRight: 5, paddingLeft: 5, marginTop: '-5px' }}>
                                    <Grid container rowSpacing={0} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
                                        <Grid item xs={6} >
                                            <Grid item xs={12} textAlign="center" >
                                                <Typography style={{ color: colors.neutral['white'], fontSize: 32, lineHeight: "8vh" }} >
                                                    Machine
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} textAlign="center"  >
                                                <ItemMachine style={{ height: '12vh' }}>
                                                    <Grid item xs={12}>
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 64, fontWeight: 'bold', lineHeight: "10vh" }} textAlign="center">
                                                            {(machine_4?.VALUE == undefined ? 0 : Math.round(machine_4?.VALUE / 60))}
                                                        </Typography>
                                                    </Grid>
                                                </ItemMachine>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={6} style={{ paddingLeft: 5 }}>
                                            <Grid item xs={12} textAlign="center" >
                                                <Typography style={{ color: colors.neutral['white'], fontSize: 32, lineHeight: "8vh" }} >
                                                    Manual
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} textAlign="center" >
                                                <ItemManual style={{ height: '12vh' }}>
                                                    <Grid item xs={12} textAlign="center" >
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 64, fontWeight: 'bold', lineHeight: "10vh" }} textAlign="center">
                                                            {smd5086?.END_TIME2 == undefined || smd5086?.END_TIME2 === "00:00" ? 0 : smd5086?.END_TIME2 <= 0 ? 0 : differenceInMinutes5086}
                                                        </Typography>
                                                    </Grid>
                                                </ItemManual>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Item>
                        </Grid>
                    }

                    {reset_dashboard_5?.VALUE == true
                        ? <Grid item xs={2.32} style={{ height: '284px' }}>
                            <ItemUT>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 3 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                        <Button
                                            variant="outlined"
                                            sx={{
                                                width: 38,
                                                height: 38,
                                                borderRadius: "50%",
                                                minWidth: "unset",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: 0,
                                                fontSize: 28,
                                                fontWeight: "bold",
                                                color: machine_status5087?.VALUE == undefined ? '#ffffff' : font_color_machine_number5(),
                                                backgroundColor: color_machine_number5(),
                                                borderColor: machine_status5087?.VALUE == undefined ? '#848484' : color_machine_number5(),
                                                transition: "0.2s ease-in-out",
                                                pointerEvents: "none",
                                            }}
                                        >
                                            5
                                        </Button>                                   
                                    </Box>
                                </Grid>
                            </ItemUT>
                            <Item sx={{ minHeight: { xs: "245px", md: "515px" }, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', background: machine_status5087?.VALUE == undefined ? 'transparent' : background_color_machine_number5() }}>
                                <Grid item xs={12} textAlign="center" sx={{ position: "relative", marginTop: { xs: "10px", md: "32px" } }}>
                                    <DonutChartMultiStepTime
                                        act={0}
                                        diff={10}
                                        step={''}
                                        time={''}
                                        mins={''}
                                    />
                                </Grid>
                            </Item>
                        </Grid>
                        : <Grid item xs={2.32} style={{ height: '284px' }}>
                            <ItemUT>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 3 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                        <Button
                                            variant="outlined"
                                            sx={{
                                                width: 38,
                                                height: 38,
                                                borderRadius: "50%",
                                                minWidth: "unset",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: 0,
                                                fontSize: 28,
                                                fontWeight: "bold",
                                                color: machine_status5087?.VALUE == undefined ? '#ffffff' : font_color_machine_number5(),
                                                backgroundColor: color_machine_number5(),
                                                borderColor: machine_status5087?.VALUE == undefined ? '#848484' : color_machine_number5(),
                                                transition: "0.2s ease-in-out",
                                                pointerEvents: "none"
                                            }}
                                        >
                                            5
                                        </Button>                                      
                                    </Box>
                                </Grid>
                            </ItemUT>
                            <Item sx={{ minHeight: { xs: "245px", md: "500px" }, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', background: machine_status5087?.VALUE == undefined ? 'transparent' : background_color_machine_number5() }}>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 15 }}>
                                    <Typography style={{ color: colors.neutral['white'], fontSize: 40, lineHeight: "0px", paddingTop: 0 }} >
                                        {name_5?.VALUE == undefined ? '' : name_5?.VALUE}
                                    </Typography>
                                </Grid>
                                {machine_state_5?.VALUE == 1024
                                    ? <Grid item xs={12} textAlign="center" sx={{ position: "relative", marginTop: { xs: "10px", md: "28px" }, marginBottom: { xs: "16vh", md: "1.2vh" } }}>
                                        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                                            <CircularProgress size={160} style={{ color: '#0cc694' }} />
                                            <Box
                                                sx={{
                                                    top: 0,
                                                    left: 0,
                                                    bottom: 0,
                                                    right: 0,
                                                    position: 'absolute',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: '24px',
                                                    color: '#fff',
                                                    fontFamily: 'CPF_Imm_Sook',
                                                    fontWeight: 'bold',
                                                }}
                                            >
                                                Loading...
                                            </Box>
                                        </Box>
                                    </Grid>
                                    : <Grid item xs={12} textAlign="center" sx={{ position: "relative", marginTop: { xs: "5px", md: "14px" } }}>
                                        <DonutChartMultiStepTime
                                            act={(machine_5?.VALUE == undefined ? 0 : machine_5?.VALUE)}
                                            diff={diff_5}
                                            step={'Step ' + (actual_step_5?.VALUE == undefined ? '' : actual_step_5?.VALUE)}
                                            time={count_down_5?.VALUE == undefined ? '00:00' : formatSecondsToHHmm(count_down_5?.VALUE)}
                                            mins={''}
                                        />
                                    </Grid>}
                                <Grid item xs={12} textAlign="center" sx={{ position: "relative", marginTop: { xs: "-46px", md: "10px" } }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                        <table style={{ width: '50%' }}>
                                            <tbody>
                                                <tr >
                                                    <td style={{ width: '40%', color: colors.neutral['grey'], fontSize: 36, lineHeight: "5vh" }} align="left">
                                                        Start&nbsp;
                                                    </td>
                                                    <td style={{ width: '20%', color: colors.neutral['white'], fontSize: 46, fontWeight: 'bold', lineHeight: "5vh" }} align="right">
                                                        {smd5087?.START_TIME == undefined ? '00:00' : formatDurationHHmm(smd5087?.START_TIME)}
                                                    </td>
                                                </tr>

                                                <tr >
                                                    <td style={{ width: '40%', color: colors.neutral['grey'], fontSize: 36, lineHeight: "10vh", paddingTop: 5 }} align="left">
                                                        End
                                                    </td>
                                                    <td style={{ width: '20%', color: smd5087?.END_TIME2 == undefined ? colors.neutral['white'] : smd5087?.END_TIME2 <= 0 ? colors.neutral['grey'] : colors.neutral['white'], fontSize: 46, fontWeight: 'bold', lineHeight: "10vh" }} align="left">
                                                        {smd5087?.END_TIME2 == undefined ? '00:00' : smd5087?.END_TIME2 <= 0 ? formatDurationHHmm(smd5087?.END_TIME1) : formatDurationHHmm(smd5087?.END_TIME2)}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} textAlign="center" style={{ paddingTop: 0, paddingRight: 5, paddingLeft: 5, marginTop: '-5px' }}>
                                    <Grid container rowSpacing={0} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
                                        <Grid item xs={6} >
                                            <Grid item xs={12} textAlign="center" >
                                                <Typography style={{ color: colors.neutral['white'], fontSize: 32, lineHeight: "8vh" }} >
                                                    Machine
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} textAlign="center"  >
                                                <ItemMachine style={{ height: '12vh' }}>
                                                    <Grid item xs={12}>
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 64, fontWeight: 'bold', lineHeight: "10vh" }} textAlign="center">
                                                            {(machine_5?.VALUE == undefined ? 0 : Math.round(machine_5?.VALUE / 60))}
                                                        </Typography>
                                                    </Grid>
                                                </ItemMachine>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={6} style={{ paddingLeft: 5 }}>
                                            <Grid item xs={12} textAlign="center" >
                                                <Typography style={{ color: colors.neutral['white'], fontSize: 32, lineHeight: "8vh" }} >
                                                    Manual
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} textAlign="center" >
                                                <ItemManual style={{ height: '12vh' }}>
                                                    <Grid item xs={12} textAlign="center" >
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 64, fontWeight: 'bold', lineHeight: "10vh" }} textAlign="center">
                                                            {smd5087?.END_TIME2 == undefined || smd5087?.END_TIME2 === "00:00" ? 0 : smd5087?.END_TIME2 <= 0 ? 0 : differenceInMinutes5087}
                                                        </Typography>
                                                    </Grid>
                                                </ItemManual>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Item>
                        </Grid>
                    }
                </Grid>
            </Grid>
        </>
    )
}

export default TumblerTracking
